<template>
	<div class="layout flex">
		<Sidebar v-if="isLogged" />
		<MainContainer class="grow">
			<slot />
		</MainContainer>
	</div>
</template>

<script lang="ts" setup>
import { computed } from "vue"
import { useAuthStore } from "@/stores/auth"
import MainContainer from "./MainContainer.vue"
import Sidebar from "./Sidebar.vue"
import "./main.scss"

const authStore = useAuthStore()
const isLogged = computed(() => authStore.isLogged)
</script>

<style lang="scss" scoped>
.layout {
	width: 100vw;
	height: 100vh;
	height: 100svh;
	overflow: hidden;
	perspective: 1000px;
}
</style>
